import {
  Card,
  CrudMode,
  Grid,
  Stack,
  useElementBreakpoints,
  RichTextEditor,
} from "@compass/core";
import { FilePanel, Select } from "components";
import {
  ApplicationResponseFile,
  StudentApplicationEditResource,
  UploadFile,
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useEffect, useState } from "react";
import { initDataModel } from "utils";

export type StudentLinkTypeTab = "Existing Student" | "New Student";
const tabs: StudentLinkTypeTab[] = ["Existing Student", "New Student"];

export const FileDetailBody = (props: {
  crudMode: CrudMode;
  applicationResponseFile: ApplicationResponseFile | undefined;
  applicationFileResource: StudentApplicationEditResource | undefined;
  setEditingApplicationResponseFile: (value: React.SetStateAction<ApplicationResponseFile | undefined>) => void;
}) => {
  const [uploadFile, setUploadFile] = useState<UploadFile>();
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  useEffect(() => {
    if (uploadFile && props.applicationResponseFile) {
      props.setEditingApplicationResponseFile(
        produce(props.applicationResponseFile, (draft) => {
          draft!.uploadFile = uploadFile;
        })
      )
    }
  }, [uploadFile]);

  return (
    <Stack spacing="lg">
      <Card ref={breakpointsRef}>
        <Stack spacing="xl">
          <Grid container spacing="sm">
            <Grid item xs={6}>
              <FilePanel
                fileName={uploadFile?.fileName}
                fileSize={uploadFile?.fileSize}
                fileRef={uploadFile?.fileRef}
                onFileChange={(fileName, fileSize, uploadingData) => {
                  let t = initDataModel<UploadFile>({
                    fileName: fileName,
                    fileSize: fileSize,
                    uploadingData: uploadingData,
                  });
                  setUploadFile(t);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Select
                label="Category"
                value={props.applicationFileResource?.fileCategories?.find((x) => x.id === props.applicationResponseFile?.fileCategoryId)}
                options={props.applicationFileResource?.fileCategories}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => {
                  props.setEditingApplicationResponseFile(
                    produce(props.applicationResponseFile, (draft) => {
                      draft!.fileCategoryId = value?.id;
                    })
                  )
                }}
              />
            </Grid>
            {props.applicationResponseFile && (
              <Grid item xs={12}>
                <RichTextEditor
                  label="Note"
                  value={props.applicationResponseFile!.note}
                  onChange={(value) =>
                    props.setEditingApplicationResponseFile(
                      produce(props.applicationResponseFile, (draft) => {
                        draft!.note = value!;
                      })
                    )
                  }
                />
              </Grid>
            )}
          </Grid>
        </Stack>
      </Card>
    </Stack>
  );
};
